export const ROOT = 'root'
export const REGISTRAR = 'Registrar'
export const DISTRICT_ADMIN = 'District Admin'
export const DATEFORMAT = 'MM/DD/YYYY'
export const DATEFORMATPLACEHOLDER = 'MM/DD/YYYY'
export const DATETIMEFORMATPLACEHOLDER = 'MM/DD/YYYY HH:mm'
export const DATEFORMATWITHTIME = 'MM/DD/YYYY HH:mm:ss'
export const US_COUNTRY_CODE = 'US'
export const CANADA_COUNTRY_CODE = 'CA'
export const NUMBER_SYMBOLS = ['e', 'E', '+', '-', '.']
export const WITH_DECIMAL_NUMBER_SYMBOLS = ['e', 'E', '+', '-']
export const TERMS_LAST_YEAR = 99

let ROUTEMAP = null

export const ROUTE = () => {
  if (ROUTEMAP === null) {
    // let { parent } = getDependencies()
    // const app = selectAppData(STORE.getState())
    // let relativePath = parent === 'remote' ? `/sis/easygradermodule` : `/sis/easygradermodule`
    let relativePath = `/sis/easygradermodule`
    ROUTEMAP = {
      LOGIN: `/login`,
      FORGOTPASSWORD: `${relativePath}/forgotpassword`,
      NOT_FOUND: `${relativePath}/pagenotfound`,
      PROGRAMS: `${relativePath}/programs`,
      COURSES: `${relativePath}/courses`,
      ADMINDETAILS: `${relativePath}/profile/:userId`,
      SETTINGS: `${relativePath}/settings`,
      USERS: `${relativePath}/users`,
      EASYGRADER: `${relativePath}/easygradermodule/rubrics`,
      BENCHMARK: `${relativePath}/easygradermodule/benchmark`,
      TEMPLATES: `${relativePath}/easygradermodule/templates`,
      EDIT_TEMPLATE: `${relativePath}/easygradermodule/templates/edit-template`,
      ANALYTICS: `${relativePath}/analytics`,
      MODEL_EXTENSIONS: `${relativePath}/easygradermodule/modelextensions`,
      ADD_BENCHMARK: `${relativePath}/easygradermodule/addbenchmark`,
      PLAGARISM_DETAILS: `${relativePath}/easygradermodule/plagarismreport`,
      GRADING: `${relativePath}/easygradermodule/details`,
      SIS_DASHBOARD: `sis/dashboard`,
      ALLENROLLMENTS: 'sis/allenrollments',
      LMS: 'sis/lms/course-master',
      SCORE_OVERRIDES: `${relativePath}/easygradermodule/scoreoverrides`,
    }
  }
  return ROUTEMAP
}

export const EASYGRADER_STATES = {
  RECEVIED: 'received',
  PROCESSING: 'processing',
  GRADED: 'graded',
  COMPLETED: 'completed',
  FAILED: 'failed',
}

export const MESSAGE_SEVERITIES = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
}

export const TablePageData = {
  current_page: 1,
  from: 1,
  last_page: 1,
  per_page: 10,
  to: 0,
  total: 0,
  query: '',
  per_page_options: [5, 10, 25, 50, 75, 100, 200],
}

export const ROLE_KINDS = {
  SYSTEM: 'SYSTEM',
  CUSTOM: 'CUSTOM',
  PREDEFINED: 'PREDEFINED',
}

export const MENUITEMS = {
  ADMINS: 'Admins',
  EASYGRADER: 'Submissions',
  BENCHMARK: 'Benchmark',
  MODEL_EXTENSIONS: 'Model Extensions',
  ANALYTICS: 'Analytics',
  SCORE_OVERRIDES: 'Score Overrides',
  TEMPLATES: 'Templates',
}

export const THEME = {
  LIGHT: 'light',
  DARK: 'dark',
}

export const DEPENDENCIES = {
  MAIN: 'main',
  REMOTE: 'remote',
}

export const MODULES = {
  LMS: 'LMS',
  SIS: 'SIS',
  EASYGRADER: 'EASYGRADER',
}

export const ERROR400S = Object.freeze({
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PAYMENTREQUIRED: 402,
  FORBIDDEN: 403,
  NOTFOUND: 404,
  INVALIDMETHOD: 405,
  NOTACCEPTABLE: 406,
  PROXYAUTHREQUIRED: 407,
  TIMEOUT: 408,
  CONFLICT: 409,
  GONE: 410,
  LENGTHREQUIRED: 411,
  PRECONDITION_FAILED: 412,
  PAYLOAD_TOO_LARGE: 413,
  URI_LONG: 414,
  UNSUPPORTED_MEDIA: 415,
  RANGE_UNSATISFIABLE: 416,
  EXPECTATION_FAILED: 417,
  TEAPOT: 418,
  MISDIRECTED_REQUEST: 421,
  UNPROCESSABLE_ENTITY: 422,
  LOCKED: 423,
  FAILED_DEPENDENCY: 424,
  TOO_EARLY: 425,
  UPGRADE_REQUIRED: 426,
  PRECONDITION_REQUIRED: 428,
  TOO_MANY_REQUESTS: 429,
  HEADER_LARGE: 431,
  UNAVAILABLE_LEGAL: 451,
  INTERNAL: 500,
})

export const NOTIFICATION_TYPE = {
  CREATE_DISTRICT: 'INAPP_NOTIFICATION_CREATE_DISTRICT',
  CREATE_SCHOOL: 'INAPP_NOTIFICATION_CREATE_SCHOOL',
  CREATE_USER: 'INAPP_NOTIFICATION_CREATE_USER',
  COURSE_UPDATE_STATUS: 'INAPP_NOTIFICATION_COURSE_UPDATE_STATUS',

  ENROLMENT_PAYMENT_SUCCESS: 'INAPP_NOTIFICATION_ENROLMENT_PAYMENT_SUCCESS',
  ENROLMENT_PAYMENT_FAILED: 'INAPP_NOTIFICATION_ENROLMENT_PAYMENT_FAILED',
  PRE_PAYMENT_SUCCESS: 'INAPP_NOTIFICATION_PRE_PAYMENT_SUCCESS',
  PRE_PAYMENT_FAILED: 'INAPP_NOTIFICATION_PRE_PAYMENT_FAILED',
  REFUND_SUCCESS: 'INAPP_NOTIFICATION_REFUND_SUCCESS',
  REFUND_FAILED: 'INAPP_NOTIFICATION_REFUND_FAILED',
  ADDITIONAL_FEE_PAYMENT_SUCCESS: 'INAPP_NOTIFICATION_ADDITIONAL_FEE_PAYMENT_SUCCESS',
  ADDITIONAL_FEE_PAYMENT_FAILED: 'INAPP_NOTIFICATION_ADDITIONAL_FEE_PAYMENT_FAILED',
  RECURRING_PAYMENT: 'INAPP_NOTIFICATION_RECURRING_PAYMENT',
  ENROLMENT_ENROLLED: 'INAPP_NOTIFICATION_ENROLMENT_ENROLLED',
  ENROLMENT_UPDATE_STATUS: 'INAPP_NOTIFICATION_ENROLMENT_UPDATE_STATUS',
  ENROLMENT_DROP_CREATE: 'INAPP_NOTIFICATION_ENROLMENT_DROP_CREATE',
  ENROLMENT_DROP_STATUS_APPROVED: 'INAPP_NOTIFICATION_ENROLMENT_DROP_STATUS_APPROVED',
  ENROLMENT_DROP_STATUS_DENIED: 'INAPP_NOTIFICATION_ENROLMENT_DROP_STATUS_DENIED',
  REENROLMENT_CREATED: 'INAPP_NOTIFICATION_RE_ENROLMENT_CREATED',
  REENROLMENT_UPDATED: 'INAPP_NOTIFICATION_RE_ENROLMENT_UPDATED',
  COURSE_COMPLETED: 'INAPP_NOTIFICATION_COURSE_COMPLETED',
  RE_ENROLMENT_PAYMENT_SUCCESS: 'INAPP_NOTIFICATION_RE_ENROLMENT_PAYMENT_SUCCESS',
  RE_ENROLMENT_ENROLLED: 'INAPP_NOTIFICATION_RE_ENROLMENT_ENROLLED',

  UPDATE_TICKET_STATUS: 'INAPP_NOTIFICATION_UPDATE_TICKET_STATUS',
  ARCHIVE_TICKET_STATUS: 'INAPP_NOTIFICATION_ARCHIVE_TICKET_STATUS',
  TICKET_ASSIGNEE_UPDATE: 'INAPP_NOTIFICATION_TICKET_ASSIGNEE_UPDATE',
  TICKET_DESCRIPTION_UPDATE: 'INAPP_NOTIFICATION_TICKET_DESCRIPTION_UPDATE',
  TICKET_PRIORITY_UPDATE: 'INAPP_NOTIFICATION_TICKET_PRIORITY_UPDATE',
  TICKET_CHANNEL_UPDATE: 'INAPP_NOTIFICATION_TICKET_CHANNEL_UPDATE',
  TICKET_COMMENT_UPDATE: 'INAPP_NOTIFICATION_TICKET_COMMENT_UPDATE',
  UNARCHIVE_TICKET_STATUS: 'INAPP_NOTIFICATION_UNARCHIVE_TICKET_STATUS',
  TICKET_CREATED: 'INAPP_NOTIFICATION_TICKET_CREATED',
  SUPER_ADMIN_ROLE: '/:SYSTEM/root',
  TICKET_COMMENT_CREATE: 'INAPP_NOTIFICATION_TICKET_COMMENT_CREATE',
  FILE_UPLOADED: 'INAPP_NOTIFICATION_FILE_UPLOADED',
  ADDITIONAL_FEE_UPDATED: 'INAPP_NOTIFICATION_ADDITIONAL_FEE_UPDATED',
  ALTERNATE_PROGRAM_TRACK_DISABLE: 'INAPP_NOTIFICATION_ALTERNATE_PROGRAM_TRACK_DISABLE',
  ALTERNATE_PROGRAM_TRACK_ENABLE: 'INAPP_NOTIFICATION_ALTERNATE_PROGRAM_TRACK_ENABLE',
  ADDITIONAL_FEE_STORE_PAYMENT_SUCCESS: 'INAPP_NOTIFICATION_ADDITIONAL_FEE_STORE_PAYMENT_SUCCESS',
  ADDITIONAL_FEE_STORE_PAYMENT_FAILED: 'INAPP_NOTIFICATION_ADDITIONAL_FEE_STORE_PAYMENT_FAILED',
}

export const WIDGET_NAMES = {
  SUBMISSION_COUNT_BY_STATUS: 'Submission Count by Status',
  SUBMISSION_COUNT_BY_MODEL: 'Submission Count by Model',
  TOP_5_COURSES: 'Top 5 Courses',
  EVALUATION_ACCURACY: 'Evaluation Accuracy',
  COMPLETION_TIME: 'Completion Time',
  SCORE_DEVIATION: 'Score Deviation',
}

export const WIDGET_DATA = [
  {
    widgets: WIDGET_NAMES.SUBMISSION_COUNT_BY_STATUS,
    position: 1,
    user_urn: '',
  },
  {
    widgets: WIDGET_NAMES.SUBMISSION_COUNT_BY_MODEL,
    position: 2,
    user_urn: '',
  },
  {
    widgets: WIDGET_NAMES.TOP_5_COURSES,
    position: 3,
    user_urn: '',
  },
  {
    widgets: WIDGET_NAMES.EVALUATION_ACCURACY,
    position: 4,
    user_urn: '',
  },
  {
    widgets: WIDGET_NAMES.COMPLETION_TIME,
    position: 5,
    user_urn: '',
  },
  {
    widgets: WIDGET_NAMES.SCORE_DEVIATION,
    position: 6,
    user_urn: '',
  },
]
